
import Vue from 'vue';
import axios from "axios";

function compare(a, b) {
  if (a.name.toLowerCase() < b.name.toLowerCase())
    return -1;
  if (a.name.toLowerCase() > b.name.toLowerCase())
    return 1;
  return 0;
}

export default Vue.extend({
  name: 'InvoiceList',
  data() {
    return {
      invoices: [],
      message: "",
      landCountryID: "Russia",
      number: "",
      customer: null,
      legalEntity: null,
      department: null,
      branch: null,
      customers: [],
      legalEntities: [],
      departments: [],
      branches: [],
      signers: [{
        "id": 0,
        "surname": "",
        "first_name": "",
        "middle_name": "",
        "phone_number": {"Int64": 0, "Valid": true},
        "display_name": "Все",
        "can_be_signer": true,
        "country_id": "ru",
        "external_id": 0,
        "is_blocked": false,
        "registration_date": "2013-12-04T00:00:00Z",
        "is_test": false,
        "accounting_name": "",
        "can_get_premium": false,
        "email": {"String": "", "Valid": false}
      }],
      invoiceStatusList: [
        {"id": 0, "name": "Все"}
      ],
      typeId: 1,
      signerId: 0,
      status: 0,
    }
  },
  methods: {
    onCustomerSearch(search, loading) {
      // loading(true);

      axios.get(`/customer_search`, {
        params: {
          landCountryID: this.landCountryID,
          name: search
        }
      })
          .then((res) => {
            console.log(res.data);
            this.customers = res.data;

          })
          .catch((error) => {
            console.log(error);
            // this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            // loading(false);
          });


    },

    onEmptySearch(search, loading) {

    },


    loadCustomerOptions(customerId) {
      axios.get(`/customer/${customerId}/legal_entities`)
          .then((res) => {
            this.legalEntities = res.data;

            this.legalEntities = this.legalEntities.filter(d =>
                d.is_deleted === false
            );

            this.legalEntities.sort(compare);

          })
          .catch(error => {
            console.log(error);
          });


      axios.get(`/customer/${customerId}/departments`)
          .then((res) => {
            this.departments = res.data;

            this.departments = this.departments.filter(d =>
                d.is_deleted === false
            );

            this.departments.sort(compare);
          })
          .catch(error => {
            console.log(error);
          });

      axios.get(`/customer/${customerId}/branches`)
          .then((res) => {
            this.branches = res.data;

            this.branches = this.branches.filter(d =>
                d.is_deleted === false
            );

            this.branches.sort(compare);
          })
          .catch(error => {
            console.log(error);
          });
    },

    searchCustomer(value) {

      this.customer = value;

      if (this.customer == null) {

        localStorage.removeItem('customer');

        this.legalEntity = null;
        this.department = null;
        this.branch = null;
      } else {
        localStorage.setItem('customer', JSON.stringify(this.customer));
      }

      if (this.customer) {
        this.loadCustomerOptions(this.customer ? this.customer.id : 0);
      }

      this.searchCustomerChilds();
    },


    searchCustomerChilds() {

      if (this.customer == null) {
        this.legalEntity = null;
        this.department = null;
        this.branch = null;
      }

      axios.get(`/invoices-by-filter`, {
        params: {
          landCountryID: this.landCountryID,
          number: this.number,
          typeID: this.typeId,
          status: this.status,
          signerID: this.signerId,
          customerID: this.customer ? this.customer.id : 0,
          legalEntityID: this.legalEntity ? this.legalEntity.id : 0,
          departmentID: this.department ? this.department.id : 0,
          branchID: this.branch ? this.branch.id : 0,
        },
      })
          .then((res) => {
            if (res.data == 'null') {
              this.invoices = [];
            } else {
              this.invoices = res.data;
            }
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
            this.invoices = [];
          });

      // this.$store.dispatch("setDocsById", {
      //     doc_id: this.searchDocId,
      //     brand: this.searchBrand,
      //     countryId: this.countryId,
      //     typeId: this.typeId,
      //     customerId: this.customer ? this.customer!.id : 0,
      //     legalEntityId: this.legalEntity ? this.legalEntity.id : 0,
      //     departmentId: this.department ? this.department.id : 0,
      //     branchId: this.branch ? this.branch.id : 0,
      //     signerId: this.signerId,
      //     status: this.status,
      // });
    },

    switchCountry() {

      let customer = this.customer

      let landCountryID = localStorage.getItem('landCountryID');
      if (landCountryID != null) {
        if (this.landCountryID != landCountryID) {
          customer = null;
          this.customer = null;
          this.customers.splice(0);

          localStorage.setItem('landCountryID', this.landCountryID);
        }
      }

      localStorage.setItem('typeId', this.typeId.toString());
      localStorage.setItem('signerId', this.signerId.toString());
      localStorage.setItem('status', JSON.stringify(this.status));

      localStorage.setItem('customer', JSON.stringify(customer));

      // this.onCustomerSearch("", null);
      this.searchCustomer(customer);
    },

    search() {
      this.onCustomerSearch("", null);
      this.searchCustomer(null);
    }
  },

  created() {
    document.title = 'Акты';

    this.invoiceStatusList = this.invoiceStatusList.concat(this.$store.getters.invoiceStatuses);

    axios.get(`/signers`)
        .then((res) => {
          this.signers = this.signers.concat(res.data);
        })
        .catch(error => {
          console.log(error);
        });


    let landCountryID = localStorage.getItem('landCountryID');
    if (landCountryID != null) {
      this.landCountryID = landCountryID
    } else {
      this.landCountryID = "Russia";
      localStorage.setItem('landCountryID', this.landCountryID);
    }

    let typeId = localStorage.getItem('typeId');

    if (typeId != null) {
      this.typeId = parseInt(typeId)
    } else {
      this.typeId = 1;
      localStorage.setItem('typeId', this.typeId.toString());
    }

    let signerId = localStorage.getItem('signerId');

    if (signerId != null) {
      this.signerId = parseInt(signerId)
    } else {
      this.signerId = 0;
      localStorage.setItem('signerId', this.signerId.toString());
    }

    let status = localStorage.getItem('status');

    if (signerId != null) {
      this.status = parseInt(status)
    } else {
      this.status = 0;
      localStorage.setItem('status', this.status.toString());
    }

    let customer = localStorage.getItem('customer');

    if (customer != null) {
      this.customer = JSON.parse(customer)

      console.log("customer");
      console.log(customer);
      console.log(this.customer);
    }

    // this.onCustomerSearch("", null);
    this.searchCustomer(this.customer);
  },

});
